/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryEntryResponse } from './RevisdomAPIViewModelsEntryEntryResponse';
import {
    RevisdomAPIViewModelsEntryEntryResponseFromJSON,
    RevisdomAPIViewModelsEntryEntryResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryEntryResponseToJSON,
    RevisdomAPIViewModelsEntryEntryResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryEntryResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1List1
 */
export interface ApiResponse1List1 {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1List1
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1List1
     */
    message?: string | null;
    /**
     * Response data'sı
     * @type {Array<RevisdomAPIViewModelsEntryEntryResponse>}
     * @memberof ApiResponse1List1
     */
    data?: Array<RevisdomAPIViewModelsEntryEntryResponse> | null;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1List1
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1List1 interface.
 */
export function instanceOfApiResponse1List1(value: object): value is ApiResponse1List1 {
    return true;
}

export function ApiResponse1List1FromJSON(json: any): ApiResponse1List1 {
    return ApiResponse1List1FromJSONTyped(json, false);
}

export function ApiResponse1List1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1List1 {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RevisdomAPIViewModelsEntryEntryResponseFromJSON)),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1List1ToJSON(json: any): ApiResponse1List1 {
    return ApiResponse1List1ToJSONTyped(json, false);
}

export function ApiResponse1List1ToJSONTyped(value?: ApiResponse1List1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RevisdomAPIViewModelsEntryEntryResponseToJSON)),
        'errors': value['errors'],
    };
}

